module.exports = __webpack_public_path__ + "img/public_4.fdf872b6.jpg";